<template>
    <section class="infinite-scroll">
      <infinite-loading :direction="direction" :identifier="identifier" @infinite="$emit('on-scroll', $event)">
        <div slot="spinner">
          <VcLoader/>
        </div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
      <div class="no-results-wrapper" v-if="isEmpty">
        <slot>
          <NoResultsCmp
            :icon="noResultIcon"
            :text="noResultTxt" />
        </slot>
      </div>
    </section>
</template>

<script>
import NoResultsCmp from "@/modules/common/components/NoResultsCmp/NoResultsCmp"
import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: "InfiniteScroll",
  components: {
    NoResultsCmp,
    InfiniteLoading,
  },
  props: {
    direction: {
      type: String,
      default: 'bottom'
    },
    noResultIcon: {
      type: String,
      default: 'icon-folder'
    },
    noResultTxt: {
      type: String,
      required: true
    },
    isEmpty: {
      type: Boolean,
      required: true
    },
    identifier: {
      type: Number,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
.infinite-scroll {
  .no-results-wrapper {
    height: 100%;
  }
}

</style>
